import liveSiteClock from '@/mixins/liveSiteClock'
import {
  operationBrandList,
  operationClosingDay,
  operationPath,
  operationRunning,
  visitorCode,
} from '@/utils/commercialOperation'

export default {
  mixins: [liveSiteClock],
  methods: {
    operationDiscountOf(offer) {
      return this.$t('components.commercialOperationBanner.discount', {
        value: offer.value,
      })
    },
  },
  computed: {
    operation() {
      return this.$store.state.commercial_operation
    },
    operationOffer() {
      if (!operationRunning(this.operation, this.siteNow)) return null
      return visitorCode(this.operation, {
        loggedIn: this.$auth.loggedIn,
        user: this.$auth.user,
      })
    },
    operationPagePath() {
      return operationPath(
        this.operation.slug,
        this.$i18n.locale,
        this.$i18n.defaultLocale
      )
    },
    operationDiscount() {
      return this.operationDiscountOf(this.operationOffer)
    },
    operationBrandsNote() {
      return this.$tc(
        'components.commercialOperationBanner.brandsNote',
        this.operationOffer.brands?.length || 1,
        { brands: operationBrandList(this.$i18n.locale, this.operationOffer) }
      )
    },
    operationLastDay() {
      return operationClosingDay(
        this.$i18n.locale,
        this.operation.closes_at,
        'full'
      )
    },
  },
}
